// extracted by mini-css-extract-plugin
export default {"control":"control_control__kcPGe","addIcon":"control_addIcon__3RrwX"};